module.exports = __webpack_public_path__ + "static/media/acm-logo.cde7daf2.jpg";